export default __webpack_public_path__ + "static/media/cert2.d0674e89.jpeg";